// Turbolinks keeps the users's scroll position even on pages that it shouldn't
// This may be due to changes in <head> or other issues listed in the issue below:
// https://github.com/turbolinks/turbolinks/issues/181#issuecomment-426869211

import ScrollPositionHelper from 'lib/scroll-position-helpers';
import StickyScrollPositionHelper from 'lib/sticky-scroll-position-helpers';
import { splitTestEnabled } from 'lib/helpers';

const applyTurbolinksScrollPatch = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  window.EezyScrollPositionHelper = ScrollPositionHelper;
  window.EezyStickyScrollPositionHelper = StickyScrollPositionHelper;

  window.addEventListener('turbolinks:load', () => {
    window.EezyScrollPositionHelper.setScrollPosition();

    if (splitTestEnabled('vertical-grid-infinite-scroll')) {
      const filterEl = document.querySelector('.search-sidebar__sticky-wrapper__inner');
      if (filterEl) window.EezyStickyScrollPositionHelper.setScrollPosition(filterEl);
    }
  });
};

export default applyTurbolinksScrollPatch;
